import React from "react";

export default function OurProducts() {
  return (
    <div className="flex items-center justify-center min-h-[70vh] text-white text-center">
      <div>
        <h1 className="text-4xl font-bold mb-4">🚧 Stay Tuned</h1>
        <p className="text-lg text-gray-300">
          Our products are coming soon. We are working hard behind the scenes.
        </p>
      </div>
    </div>
  );
}
